function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Tab, Tabs as MUITabs } from '@material-ui/core';
import uniqueId from 'lodash.uniqueid';
const verticalTabWidth = '160px';
const useStyles = makeStyles(theme => ({
  container: {
    color: 'white',
    display: ({
      orientation
    }) => orientation === 'vertical' ? 'flex' : 'block'
  },
  postTabsContentContainer: {
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    marginLeft: ({
      orientation
    }) => orientation === 'vertical' ? undefined : 'auto'
  },
  tabs: {
    flexShrink: ({
      orientation
    }) => orientation === 'vertical' ? 0 : 1,
    width: ({
      orientation
    }) => orientation === 'vertical' ? verticalTabWidth : undefined
  },
  tabsContainer: {
    backgroundColor: theme.palette.primary[500],
    display: 'flex',
    flexDirection: ({
      orientation
    }) => orientation === 'vertical' ? 'column' : 'row',
    maxWidth: '100%'
  },
  tabPanel: {
    backgroundColor: 'white',
    color: theme.palette.text.primary,
    flexGrow: 1,
    maxWidth: ({
      orientation
    }) => orientation === 'vertical' ? `calc(100% - ${verticalTabWidth})` : undefined,
    // needed to keep panels from overflowing their parent elements.
    overflow: 'hidden' // fixes issue where a top margin on the first child of the panel results in a gap between the panel and the tabsContainer

  }
}));

const Tabs = ({
  onChange,
  postTabsContent,
  selectedTab,
  tabs,
  ...props
}) => {
  const classes = useStyles(props);
  const [tabsId] = useState(() => uniqueId('tabs_'));
  const selectedTabIndex = Math.max(tabs.findIndex(tab => tab.id === selectedTab), 0);
  const [visibleIndex, setVisibleIndex] = useState(selectedTabIndex);
  useEffect(() => {
    setVisibleIndex(selectedTabIndex);
  }, [selectedTabIndex]);
  return React.createElement("div", {
    className: classes.container
  }, React.createElement("div", {
    className: classes.tabsContainer
  }, React.createElement(MUITabs, _extends({
    value: visibleIndex,
    onChange: (event, visibleIndex) => {
      setVisibleIndex(visibleIndex);

      if (typeof onChange === 'function') {
        onChange(tabs[visibleIndex]);
      }
    },
    variant: "scrollable",
    className: classes.tabs
  }, props), tabs.map(({
    id,
    ...props
  }, index) => React.createElement(Tab, _extends({
    key: id,
    id: `${tabsId}-tab-${index}`,
    "aria-controls": `${tabsId}-tabpanel-${index}`
  }, props)))), React.createElement("div", {
    className: classes.postTabsContentContainer
  }, postTabsContent)), tabs.map(({
    content,
    id
  }, index) => index === visibleIndex ? React.createElement("div", {
    key: id,
    role: "tabpanel",
    id: `${tabsId}-tabpanel-${index}`,
    "aria-labelledby": `${tabsId}-tab-${index}`,
    className: classes.tabPanel
  }, content) : null));
};

Tabs.propTypes = {
  onChange: PropTypes.func,
  postTabsContent: PropTypes.element,
  selectedTab: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
    content: PropTypes.element,
    icon: PropTypes.element,
    id: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
  })).isRequired
};
export default Tabs;